<template>
  <b-modal
    :visible="visible"
    :title="config.title"
    size="md"
    no-close-on-backdrop
    :no-close-on-esc="isSaving"
    :hide-header-close="isSaving"
    @show="reset"
    @hidden="$emit('close')"
  >
    <div v-if="booking">
      <p class="mb-1"><b>Confirmación:</b> {{ booking.folio }}</p>
      <p class="mb-1"><b>Vivienda:</b> {{ booking.housingnumber }}</p>
      <slot name="summary" />

      <div v-if="config.showRequest" class="mb-2">
        <p class="mb-1"><b>Fecha de solicitud:</b> {{ requestDate }}</p>
        <p class="mb-0"><b>Motivo del propietario:</b></p>
        <p class="mb-0 notes">{{ booking.cancelRequestNotes || '—' }}</p>
      </div>

      <p v-if="config.hint" class="mb-0">{{ config.hint }}</p>

      <b-form-group v-if="config.label" :label="config.label">
        <b-form-textarea
          v-if="config.multiline"
          v-model="text"
          rows="3"
          maxlength="255"
          :state="touched && isBlank ? false : null"
          @blur="touched = true"
        />
        <b-form-input
          v-else
          v-model="text"
          type="text"
          maxlength="255"
          :state="touched && isBlank ? false : null"
          @blur="touched = true"
        />
        <b-form-invalid-feedback>Este campo es obligatorio</b-form-invalid-feedback>
      </b-form-group>
    </div>

    <template #modal-footer>
      <b-button variant="secondary" :disabled="isSaving" @click="$emit('close')">Cerrar</b-button>
      <b-button :variant="config.variant" :disabled="isMissingText || isSaving" @click="submit">
        <b-spinner small v-if="isSaving" /> {{ config.button }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatXcalacocoDateTime } from '@/helpers/xcalacocoBookingsHelper'

// Status dialog shared by the Xcalacoco stays and Beach Club details. `modes` comes from the ownerBookingDetail mixin;
// a mode without a label submits no text
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'confirm',
    },
    modes: {
      type: Object,
      required: true,
    },
    booking: {
      type: Object,
      default: null,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
      touched: false,
    }
  },
  computed: {
    config() {
      return this.modes[this.mode] || this.modes.confirm
    },
    isBlank() {
      return !this.text.trim()
    },
    isMissingText() {
      return Boolean(this.config.label) && this.isBlank
    },
    requestDate() {
      return formatXcalacocoDateTime(this.booking && this.booking.cancellationRequestDate)
    },
  },
  methods: {
    reset() {
      this.text = ''
      this.touched = false
    },
    submit() {
      if (this.isMissingText || this.isSaving) return
      this.$emit('submit', this.text.trim())
    },
  },
}
</script>

<style scoped>
.notes {
  white-space: pre-line;
}
</style>
